import { Deserializable } from '../protocols/deserializable';

export class AccountType implements Deserializable {
  id!: number;
  name!: string;
  idPrefix!: string;
  categoryId!: number;

  onDeserialize() {}
}
